export const token_360_permission= {
    required_permission:['add_token','change_token','delete_token','view_token','view_survey']
}